import { render, staticRenderFns } from "./ManageStakingCard.vue?vue&type=template&id=6718007c&scoped=true&"
import script from "./ManageStakingCard.vue?vue&type=script&lang=js&"
export * from "./ManageStakingCard.vue?vue&type=script&lang=js&"
import style0 from "./ManageStakingCard.vue?vue&type=style&index=0&id=6718007c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6718007c",
  null
  
)

export default component.exports